import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewsService } from './news.service';
import { IBlogPostNewsDetail, IBlogPostNewsLists } from './news.models';

/**
 * Resolver for news list.
 * Uploading first news items for pre-rendering.
 */
@Injectable()

export class NewsListsResolver implements Resolve<any> {
  constructor(
    private http: HttpClient,
    private newsService: NewsService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IBlogPostNewsLists> | Observable<never> {
    return this.newsService.getAllNews(20, 1);
  }
}


/**
 * Resolver for news item.
 * Uploading news item for pre-rendering.
 */
@Injectable()

export class NewsItemResolver implements Resolve<any> {
  constructor(
    private http: HttpClient,
    private newsService: NewsService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IBlogPostNewsDetail> | Observable<never> {
    return this.newsService.getNewsById(route.params.id);
  }
}

